<template>
  <div class="main">
    <Nav :authRequired = "true"/>
    <div class="container">
      <div class="row mb-x2">
        <div class="col">
          <router-link to="/cms" class="zero-btn zero-btn-standard zero-btn-primary zero-btn-outline">
            <i class="fas fa-chevron-left mr-x1"></i> BACK
          </router-link>
          <h2 v-if="!editMode">Create an Entry</h2>
          <h2 v-else>Edit Entry</h2>
        </div>
      </div>
      <div class="row mb-x4">
        <div class="col zero-form">
          <div class="input-block mb-x2">
            <label for="entry-title">
              title
            </label>
            <input
              type="text"
              id="entry-title"
              name="entry-title"
              placeholder=""
              class="standard-text-input"
              v-model="cmsData.title"
              :class="{ 'has-error': errors.title }"
              autocomplete="off"
            >
            <p class="input-error" v-if="errors.name">
              Please enter a title for the entry
            </p>
          </div>
          <div class="input-block mb-x2">
            <label for="entry-blurb">
              blurb
            </label>
            <input
              type="text"
              id="entry-blurb"
              name="entry-blurb"
              placeholder=""
              class="standard-text-input"
              v-model="cmsData.blurb_one"
              :class="{ 'has-error': errors.blurb }"
              autocomplete="off"
            >
            <p class="input-error" v-if="errors.name">
              Please enter a blurb
            </p>
          </div>
          <div class="input-block mb-x2">
            <label for="file-path">
              file path
            </label>
            <input
              type="text"
              id="file-path"
              name="file-path"
              placeholder=""
              class="standard-text-input"
              v-model="cmsData.example_file"
              :class="{ 'has-error': errors.file }"
              autocomplete="off"
              readonly
            >
          </div>
          <div class="input-block mb-x2">
            <label for="image-input">
              <div class="label-inner">file</div>
              <div class="file-drag-drop" @dragover="fileDragOver" @dragleave="fileDragLeave" @drop="fileDrop">
                Drag a single file for upload
              </div>
            </label>
            <input
              type="file"
              id="image-input"
              name="image-input"
              placeholder=""
              class="standard-text-input mb-x2"
              :class="{ 'has-error': errors.file }"
              autocomplete="off"
              ref="fileinput"
              @change="fileInputChange"
              accept=".pdf,.jpg,.jpeg,.png,.csv"
            >
          </div>
          <div class="zero-btn zero-btn-standard zero-btn-primary" @click="postEntry()" v-if="!editMode">
            Create Entry
          </div>
          <div class="zero-btn zero-btn-standard zero-btn-primary" @click="putEntry()" v-if="editMode">
            Update Entry
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import VueCookies from 'vue-cookies'
import Nav from '@/components/Nav.vue'

Vue.use(VueCookies)
// import shared from '@/shared.js'
// example usage: shared.parseDate('2012-08-11')
const axios = require('axios')

// endpoints
const localApiURL = 'http://localhost:8000/'
// const remoteApiURL = 'https://timothyreeder.com/alpha/zero-api/public/api/cms'

const apiChoice = localApiURL

// Using route params
// $route.params.id
// from path: '/user/:id',

export default {
  name: 'home',
  components: {
    Nav
  },
  data () {
    return {
      isLoading: false,
      userToken: '',
      isLoggedIn: false,
      userData: {
        'id': '',
        'name': '',
        'email': ''
      },
      cmsId: '',
      cmsData: {
        'title': '',
        'blurb_one': '',
        'example_file': ''
      },
      errors: {
        'title': false,
        'blurb': false,
        'file': false
      },
      editMode: false,
      inputFile: ''
    }
  },
  created () {
    if (this.$cookies.isKey('u')) {
      this.isLoggedIn = true
      this.userData = this.$cookies.get('u')
      this.userToken = this.$cookies.get('j') + '.' + this.$cookies.get('w') + '.' + this.$cookies.get('t')
    }
    if (this.$route.params.cmsid) {
      this.cmsId = this.$route.params.cmsid
      this.editMode = true
      this.getEntry()
    }
  },
  methods: {
    getEntry () {
      axios
        .get(apiChoice + 'api/cms/' + this.cmsId, {
          headers: {
            'Cache-Control': 'no-cache',
            'Authorization': 'Bearer ' + this.userToken
          }
        })
        .then((response) => {
          this.cmsData = response.data
          // stop loading
          // this.isLoading = false
        })
        .catch((error) => {
          console.log('error occurred')
          console.log(error)
          this.output = error.response.data
          // this.isLoading = false
        })
    },
    postEntry () {
      let formData = new FormData()
      if (document.getElementById('image-input').value !== '') {
        // let imagefile = document.querySelector('#image-input')
        // formData.append('example_file', imagefile.files[0])
        formData.append('example_file', document.getElementById('image-input').files[0])
      } else {
        formData.append('example_file', null)
      }
      formData.append('blurb_one', this.cmsData.blurb_one)
      formData.append('title', this.cmsData.title)
      axios
        .post(apiChoice + 'api/cms', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + this.userToken
          }
        })
        .then((response) => {
          // do something with response.data.data
          console.log(response)
          this.$router.push({ path: '/cms' })
          // stop loading
          // this.isLoading = false
        })
        .catch((error) => {
          console.log('error occurred')
          console.log(error)
          // this.isLoading = false
        })
    },
    putEntry () {
      let formData = new FormData()
      if (document.getElementById('image-input').value !== '') {
        formData.append('example_file', document.getElementById('image-input').files[0])
      }
      formData.append('blurb_one', this.cmsData.blurb_one)
      formData.append('title', this.cmsData.title)
      // adding this to make it a put
      formData.append('_method', 'PUT')
      // set as post to get around formdata + put not working together
      axios
        .post(apiChoice + 'api/cms/' + this.cmsId, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + this.userToken
          }
        })
        .then((response) => {
          // do something with response.data.data
          console.log(response)
          this.$router.push({ path: '/cms/' + this.cmsId })
          // stop loading
          // this.isLoading = false
        })
        .catch((error) => {
          console.log('error occurred')
          console.log(error)
          // this.isLoading = false
        })
    },
    fileInputChange () {
      // I think for single file upload this isn't necessary...
      this.inputFile = this.$refs.fileinput.files
    },
    fileDragOver (event) {
      event.preventDefault()
      // Add some visual fluff to show the user can drop its files
      if (!event.currentTarget.classList.contains('drag-on-active')) {
        event.currentTarget.classList.add('drag-on-active')
      }
    },
    fileDragLeave (event) {
      // Clean up
      event.currentTarget.classList.remove('drag-on-active')
    },
    fileDrop (event) {
      event.preventDefault()
      this.$refs.fileinput.files = event.dataTransfer.files
      this.fileInputChange() // Trigger the onChange event manually
      // Clean up
      event.currentTarget.classList.remove('drag-on-active')
    }
  }
}
</script>

<style scoped lang="scss">
.tab-content .menu-info{
  h2{
    display: block;
  }
}

// Media Queries
// Small devices (landscape phones, 576px and up)
@media (min-width: 576px) {
}
// Medium devices (tablets, 768px and up)
@media (min-width: 768px) {
}
// Large devices (desktops, 992px and up)
@media (min-width: 992px) {
}
// Extra large devices (large desktops, 1200px and up)
@media (min-width: 1200px) {
}
</style>
